import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import JobOp from "./pages/JobOp";
import Disney from "./pages/Disney";
import Dashboard from "./pages/Dashboard";
import Activities from "./pages/Activities";
import Tamwood from "./pages/Tamwood";
import Contact from "./pages/Contact";

function App() {
  const location = useLocation();
  const isDashboard = location.pathname === "/dashboard";

  return (
    <div>
      <ScrollToTop />
      {!isDashboard && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/job-opportunity" element={<JobOp />} />
        <Route path="/disney" element={<Disney />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/tamwood" element={<Tamwood />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      {!isDashboard && <Footer />}
    </div>
  );
}

export default App;
